import {
  roomAnyId,
  RoomAnyId,
  rtmpDestinationKey,
  RtmpDestinationKey
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseRequestDTO } from "@youm-front/common/domain";

export class Conf2RtmpDestinationCreateRequestDTO extends BaseRequestDTO<Conf2RtmpDestinationCreateRequestDTORaw> {
  private static validateFunction = JsonSchemaValidator.compile(
    Conf2RtmpDestinationCreateRequestDTO.validationSchema()
  );

  constructor(value: Conf2RtmpDestinationCreateRequestDTORaw) {
    super(
      JsonSchemaValidator.assert(
        Conf2RtmpDestinationCreateRequestDTO.validateFunction,
        value
      )
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["key", "roomId"],
      properties: {
        key: rtmpDestinationKey,
        roomId: roomAnyId
      },
      additionalProperties: false
    };
  }

  override toJSON(): object {
    return {
      type: "rtmp",
      destination: this.value
    };
  }
}

interface Conf2RtmpDestinationCreateRequestDTORaw {
  key: RtmpDestinationKey;
  roomId: RoomAnyId;
}
